import React from "react";
import { IoMdSearch } from "react-icons/io";
import { FaFacebookF } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaLinkedinIn } from "react-icons/fa";
import { MdOutlineWhatsapp } from "react-icons/md";
import { CiLocationOn } from "react-icons/ci";
import { GoClock } from "react-icons/go";
import { FaRegEnvelope } from "react-icons/fa";
const BottomNavbar = () => {
  return (
    <div className=" bg-[#fdfdfd]">
      <div className="lg:flex hidden justify-between py-4 px-10">
        <div className="flex gap-6 items-center w-full">
          <div className="flex items-center gap-2">
            <span className="h-10 w-10 bg-primaryColor rounded-md flex items-center justify-center">
              <CiLocationOn className="text-white" size={20} />
            </span>

            <div className="flex flex-col">
              <h3 className="text-sm font-medium ">
                1840/3294/4628, Balianta, Hanspal, Bbsr
              </h3>
              <p className="text-sm text-[#4f4f4f]">Visit Our Testing Center</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <span className="h-10 w-10 bg-primaryColor rounded-md flex items-center justify-center">
              <FaRegEnvelope className="text-white" size={20} />
            </span>
            <div className="flex flex-col">
              <a href="mailto:managingdirector@diagnonextlabs.com" className="text-sm font-medium ">managingdirector@diagnonextlabs.com</a>
              <p className="text-sm text-[#4f4f4f]">
                Send Your Mail 24/7 Support
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <span className="h-10 w-10 bg-primaryColor rounded-md flex items-center justify-center">
              <GoClock className="text-white" size={20} />
            </span>
            <div className="flex flex-col">
              <h3 className="text-sm font-medium ">Mon - Sun 06:00 AM to 09:00 PM</h3>
              <p className="text-sm text-[#4f4f4f]">Lab Operating Hours</p>
            </div>
          </div>
        </div>
        <ul className="xl:flex hidden gap-2">
          {/* <li className="h-10 w-10  rounded-full flex items-center justify-center">
            <IoMdSearch className="text-black" size={20} />
          </li> */}
          <li className="h-10 w-10 bg-primaryColor rounded-full flex items-center justify-center">
            <FaFacebookF size={20} className="text-white" />
          </li>
          <li className="h-10 w-10 bg-primaryColor rounded-full flex items-center justify-center">
            <FaXTwitter size={20} className="text-white" />
          </li>
          <li className="h-10 w-10 bg-primaryColor rounded-full flex items-center justify-center">
            <FaLinkedinIn size={20} className="text-white" />
          </li>
          <li className="h-10 w-10 bg-primaryColor rounded-full flex items-center justify-center">
            <MdOutlineWhatsapp size={20} className="text-white" />
          </li>
        </ul>
      </div>
    </div>
  );
};

export default BottomNavbar;
